import { render, staticRenderFns } from "./RewardComp.vue?vue&type=template&id=7d535d3c&scoped=true&"
import script from "./RewardComp.vue?vue&type=script&lang=js&"
export * from "./RewardComp.vue?vue&type=script&lang=js&"
import style0 from "./RewardComp.vue?vue&type=style&index=0&id=7d535d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d535d3c",
  null
  
)

export default component.exports